var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingNewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2778 3.28866C10.6903 3.05059 11.1984 3.05052 11.6108 3.28866L16.856 6.31698C17.2684 6.55511 17.5228 6.99504 17.5229 7.47128V13.5279C17.5229 14.0042 17.2685 14.445 16.856 14.6832L11.6108 17.7115C11.1984 17.9496 10.6903 17.9495 10.2778 17.7115L5.03271 14.6832C4.62015 14.445 4.36572 14.0042 4.36572 13.5279V7.47128C4.36584 6.99504 4.62027 6.55511 5.03271 6.31698L10.2778 3.28866ZM10.9438 7.2496C9.14919 7.2498 7.69402 8.70494 7.69385 10.4996C7.69385 12.2944 9.14908 13.7494 10.9438 13.7496C12.7387 13.7496 14.1938 12.2945 14.1938 10.4996C14.1937 8.70481 12.7386 7.2496 10.9438 7.2496Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingNewIcon);
export default __webpack_public_path__ + "static/media/settingNewIcon.95e3dad0f5779e8f245dc0e1ea337291.svg";
export { ForwardRef as ReactComponent };